/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { useBreakpoint } from '@cat-ecom/pcc-components/src/hooks';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import styles from './FilterFooter.module.scss';
type FilterFooterType = {
  isDisable?: boolean;
  handleFilterClear: () => void;
  closeDrawer: () => void;
  handleViewResult: () => void;
  viewResultText: string;
  clearFilterText: string;
};
export const FilterFooter: FC<FilterFooterType> = ({
  isDisable,
  handleFilterClear,
  closeDrawer,
  viewResultText,
  handleViewResult,
  clearFilterText,
}) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const width = !isMD ? 'w-100' : '';
  return (
    <div
      slot="footer"
      className={`${styles['notification_filters_drawer_btngroup']}`}
    >
      <CatButton
        fullWidth={!isMD}
        type="submit"
        variant="primary"
        data-testid="notification-apply-button"
        onClick={handleViewResult}
        className={width}
        aria-label={viewResultText}
      >
        {viewResultText}
      </CatButton>
      {isDisable && (
        <CatButton
          fullWidth={!isMD}
          variant="ghost"
          onClick={handleFilterClear}
          data-testid="notification-clear-button"
          className={width}
        >
          {clearFilterText}{' '}
        </CatButton>
      )}
    </div>
  );
};
